import { Checkbox as AntCheckbox } from 'antd'
import styled from 'styled-components'

export const Checkbox = styled(AntCheckbox)`
  && {
    transition: none;
    .ant-checkbox {
      align-self: start;
      margin-top: 2px;
    }
    &:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner,
    .ant-checkbox:not(.ant-checkbox-disabled):hover .ant-checkbox-inner {
      transition: none;
      border-color: ${(props) => props.theme.colors.checkbox.border};
      outline: 1px solid ${(props) => props.theme.colors.checkbox.focus};
      outline-offset: 1px;
    }

    &:not(.ant-checkbox-wrapper-disabled):hover
      .ant-checkbox-checked:not(.ant-checkbox-disabled)
      .ant-checkbox-inner {
      background: ${(props) => props.theme.colors.checkbox.checked};
    }

    .ant-checkbox-inner::after {
      border: none;
      background-image: url("data:image/svg+xml,%3Csvg width='12' height='9' viewBox='0 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.7613 0.21934C11.9017 0.35996 11.9806 0.55059 11.9806 0.74934C11.9806 0.94809 11.9017 1.13871 11.7613 1.27934L4.5113 8.52934C4.37067 8.66974 4.18005 8.74864 3.9813 8.74864C3.78255 8.74864 3.59192 8.66974 3.4513 8.52934L0.201296 5.27934C0.0688163 5.13716 -0.0033037 4.94912 0.000116305 4.75481C0.0035463 4.56051 0.0822562 4.37513 0.219676 4.23771C0.357086 4.1003 0.542476 4.02159 0.736776 4.01816C0.931076 4.01473 1.11912 4.08686 1.2613 4.21934L3.9813 6.93934L10.7013 0.21934C10.8419 0.0788898 11.0325 0 11.2313 0C11.43 0 11.6207 0.0788898 11.7613 0.21934Z' fill='white'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 12px 9px;
      width: 12px;
      height: 9px;
      transform: translate(-50%, -50%) scale(1) !important;
      margin-left: 0;
      inset-inline-start: 0;
      left: 50%;
    }
  }
`
